<template>
    <li class="header-menu__li">
        <input type="checkbox" class="header-menu__sub-menu-checkbox" :id="'header-menu__sub-menu-' + _uid" :name="'sub-menu-' + _uid" value="1" autocomplete="off" v-model="showMenuCheckbox" />
        <label :for="'header-menu__sub-menu-' + _uid" :class="{ 'header-menu__link': true, 'header-menu__link--label': true, 'header-menu__link--no-link': haveTitleLink }">
            {{ title }}
            <picture class="header-menu__arrow">
                <source srcset="/images/header/sub-menu-arrow.webp, /images/header/sub-menu-arrow@2x.webp 2x" type="image/webp" />
                <img srcset="/images/header/sub-menu-arrow.jpg, /images/header/sub-menu-arrow@2x.jpg 2x" alt="" />
            </picture>
        </label>
        <a v-if="haveTitleLink" :href="titleLink" class="header-menu__link header-menu__link--a">
            {{ title }}
            <picture class="header-menu__arrow">
                <source srcset="/images/header/sub-menu-arrow.webp, /images/header/sub-menu-arrow@2x.webp 2x" type="image/webp" />
                <img srcset="/images/header/sub-menu-arrow.jpg, /images/header/sub-menu-arrow@2x.jpg 2x" alt="" />
            </picture>
        </a>
        <slot></slot>
    </li>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: "",
                required: true,
            },
            titleLink: {
                type: String,
                default: "",
                required: false,
            },
            headerUnpinned: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                showMenuCheckbox: false,
            }
        },
        watch: {
            headerUnpinned(newValue) {
                if (newValue == true) {
                    this.showMenuCheckbox = false;
                    return;
                }
            },
        },
        computed: {
            haveTitleLink() {
                if (this.titleLink && this.titleLink.length > 0) {
                    return true;
                }
                return false;
            },
        },
    };
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Layout/Menus/DesktopSubMenu.vue